import { ref, computed } from 'vue'
import userService from '@/services/userService'

const PERMISSIONS_STORAGE_KEY = 'user_permissions'

const userPermissions = ref([])
let isLoaded = false

const loadPermissionsFromStorage = () => {
  try {
    const stored = localStorage.getItem(PERMISSIONS_STORAGE_KEY)
    if (stored) {
      const permissions = JSON.parse(stored)
      userPermissions.value = permissions
      isLoaded = true
      return true
    }
  } catch (error) {
    console.error('❌ [usePermissions] Erro ao carregar permissões do localStorage:', error)
  }
  return false
}


const savePermissionsToStorage = (permissions) => {
  try {
    localStorage.setItem(PERMISSIONS_STORAGE_KEY, JSON.stringify(permissions))
  } catch (error) {
    console.error('❌ [usePermissions] Erro ao salvar permissões no localStorage:', error)
  }
}

export function usePermissions() {
  
  const fetchPermissions = async () => {
    try {
      const response = await userService.getInfo()
      
      // O backend retorna uma lista de strings de permissões do Django (formato: app.codename)
      const permissionsList = response?.data?.attributes?.permissions || []
      
      userPermissions.value = permissionsList
      isLoaded = true
      
      savePermissionsToStorage(permissionsList)
      
      return permissionsList
    } catch (error) {
      console.error('❌ [usePermissions] Erro ao buscar permissões:', error)
      userPermissions.value = []
      return []
    }
  }

  
  if (!isLoaded) {
    const loaded = loadPermissionsFromStorage()
    
    if (!loaded && localStorage.getItem('tokenAccess')) {
      fetchPermissions()
    }
  }

  
  const can = (permission) => {
    // Verifica se o usuário tem a permissão exata (formato Django: app.codename)
    return userPermissions.value.includes(permission)
  }

  
  const clearPermissions = () => {
    userPermissions.value = []
    isLoaded = false
    try {
      localStorage.removeItem(PERMISSIONS_STORAGE_KEY)
    } catch (error) {
      console.error('❌ [usePermissions] Erro ao limpar permissões:', error)
    }
  }

  return {
    can,
    userPermissions: computed(() => userPermissions.value),
    refreshPermissions: async () => {
      isLoaded = false
      return fetchPermissions()
    },
    clearPermissions
  }
}
